import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Craft from './components/Craft';
import Location from './components/Location';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Craft />
        <Location />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}